
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import SelectItem2 from "components/Varios/SelectNew";
import { Table, Button, Input, PaginationItem, PaginationLink, Pagination, Row, Col, Label, FormGroup } from "reactstrap"
//import { ObtenerAniosPlanificacionHE, ObtenerInformacionPlanificacionUnidadesHE, ObtenerMesesPlanificacionHE } from "./FunctionsPlanificacionUnidades";
import { alertService } from "components/Varios/alert_service";
//import { DetallePlanificacionUnidadesHE, MesesPlanificacionHEDTO } from "./TypesPlanificacionUnidades";
import Cargando from "components/Varios/Cargando";
import CardRegimenHE from "components/DirectivoUnidad/Horas Extras/PlanificacionHE/CardRegimenHE";
import { ObtenerAniosPlanificacionHE } from "components/Admin/Horas Extras/Planificacion Horas Extras/FunctionsPlanificacionUnidades";
import { PresupuestoPlanificacionHistoricoHEDTO } from "../PlanificacionHE/TypesPlanificacionHE";
import { ObtenerInformacionHistorialPresupuestoPlanificacionHE } from "../PlanificacionHE/FunctionsPlanificacionHE";
///import TablaPlanificacionUnidadesHE from "./TablaPlanificacionUnidadesHE";

import { showAlert } from "components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import ErrorSVG from "../../../../assets/icons/HorasExtras/Error.svg"
import CardRegimenHEInicio from "../PlanificacionHE/CardRegimenHEInicio";

export default function HistorialPlanificacion() {
    const defaultHistorialPresubpuestoPlanificacion = {
        anio: 0,
        detalleRegimenPresupuestobyMes: []
    }

    const TITULO_PANTALLA = `RESUMEN DE LAS PLANIFICACIONES MENSUALES DE HORAS EXTRAS`;

    const [loading, setloading] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const [aniosPlanificacion, setAniosPlanificacion] = useState<number[]>([]);
    //const [mesesPlanificacion, setMesesPlanificacion] = useState<MesesPlanificacionHEDTO[]>([]);

    const [anioSeleccionado, setAnioSeleccionado] = useState<number>(0);
    const [mesSeleccionado, setMesSeleccionado] = useState<number>(0);

    const [historialPresupuestoPlanificacion, sethistorialPresupuesPlanificacion] = useState<PresupuestoPlanificacionHistoricoHEDTO>(defaultHistorialPresubpuestoPlanificacion);


    //const [infGeneralPlanificacionUnidades, setinfGeneralPlanificacionUnidades] = useState<DetallePlanificacionUnidadesHE>(defaultPlanificacionUnidades);

    async function ObtenerAniosPlanificacion() {
        setloading(true)
        const informacionGeneral = await ObtenerAniosPlanificacionHE();
        if (informacionGeneral.status === 200 && typeof informacionGeneral.dataResponse !== 'string') {
            setAniosPlanificacion(informacionGeneral.dataResponse)
            setErrorMessage(null);
        } else {
            setAniosPlanificacion([]); // Set an empty state
            setErrorMessage(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Set the error message
            alertService.error(typeof informacionGeneral.errorMessage === 'string' ? informacionGeneral.errorMessage : 'Error desconocido'); // Show the error alert
        }
        setloading(false)
    }

    async function ObtenerInformacionGeneral() {
        setloading(true)
        const informacionGeneral = await ObtenerInformacionHistorialPresupuestoPlanificacionHE(anioSeleccionado);
        
        if (informacionGeneral.status === 200 && informacionGeneral.dataResponse ) {

            if(typeof informacionGeneral.dataResponse !== 'string') {
                sethistorialPresupuesPlanificacion(informacionGeneral.dataResponse)
            }
            else {  
                sethistorialPresupuesPlanificacion(defaultHistorialPresubpuestoPlanificacion); // 
                showAlert(informacionGeneral.errorMessage??'', true, ErrorSVG)

                 
            }
            
        } else {
            sethistorialPresupuesPlanificacion(defaultHistorialPresubpuestoPlanificacion);
            showAlert(informacionGeneral.errorMessage??'', true, ErrorSVG) // Set an empty state
        }
        setloading(false)
    }

    useEffect(() => {
        if(anioSeleccionado !== 0){
            ObtenerInformacionGeneral()
        }        
    }, [anioSeleccionado])

    

    useEffect(() => {
        ObtenerAniosPlanificacion()
    }, [])

    

    const handleChangeSelect = (setter: Dispatch<SetStateAction<number>>) => (value: string | number) => {
        setter(Number(value)); 
    };

    const contenidoCardRegimen = (
        <Row>
            <Col xl={12}>
                <Row>
                    {historialPresupuestoPlanificacion.detalleRegimenPresupuestobyMes.map((regimen, index) => (
                        <Col xl={4} key={index} className="mb-3 same-height-container">
                            <CardRegimenHEInicio
                                anio={historialPresupuestoPlanificacion.anio}
                                nombreMes={regimen.key.nombreMes}
                                numeroMes={regimen.key.numeroMes}
                                puedeRealizarAccion={regimen.key.puedeRealizarAccion?regimen.key.puedeRealizarAccion:false}
                                regimenLaboralPlan={regimen.value}
                                index={index}
                                
                            />
                        </Col>
                    ))}
                </Row>
            </Col>
        </Row>
    );

    return (
        <div className='content'>
            <div className="titulo_seccion mb-3"> 
                {TITULO_PANTALLA}                
            </div>

            <Row>
                <Col xl={2}>
                    <FormGroup>
                        <Label for="anio">Año*</Label>
                        <SelectItem2
                            options={aniosPlanificacion.map(anio => ({ value: anio, label: anio }))}
                            placeholder=""
                            name="anio"
                            id="anio"
                            icon="fa-caret-down"
                            value={anioSeleccionado}
                            onChange={handleChangeSelect(setAnioSeleccionado)}
                        />
                    </FormGroup>
                </Col>
            </Row>

            <>
            {loading && <Cargando />}
            {!loading && contenidoCardRegimen}

            </>
        </div>
    )
}
